<div class="card card-flush">
  <!-- Filters Section -->
  <div class="card-body border-bottom py-4 proforma-filters" *ngIf="showFilters" [@slideInOut]>
    <div class="row g-4">
      <!-- Customer Search -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Customer</label>
        <div class="position-relative">
          <input type="text" class="form-control form-control-sm" placeholder="Search Customer..."
            [(ngModel)]="customerSearchTerm" (input)="onCustomerSearchInput($event)" (focus)="onCustomerInputFocus()"
            (blur)="onCustomerInputBlur()" autocomplete="off" />

          <!-- Customer Search Results Dropdown -->
          <div class="dropdown-menu show w-100 mh-300px overflow-auto"
            *ngIf="showCustomerDropdown && (customerSearchResults.length > 0 || isCustomerSearching)">

            <!-- Loading State -->
            <div class="dropdown-item text-center py-3" *ngIf="isCustomerSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching customers...
            </div>

            <!-- Search Results -->
            <a class="dropdown-item cursor-pointer py-2" *ngFor="let customer of customerSearchResults"
              (click)="selectCustomer(customer)">
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ getCustomerDisplayName(customer) }}</span>
                <small class="text-muted">{{ customer.email }}</small>
              </div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
              *ngIf="!isCustomerSearching && customerSearchResults.length === 0">
              No customers found
            </div>
          </div>
        </div>
      </div>

      <!-- Sales Person Search -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sales Person</label>
        <div class="position-relative">
          <input type="text" class="form-control form-control-sm" placeholder="Search Sales Person..."
            [(ngModel)]="salesPersonSearchTerm" (input)="onSalesPersonSearchInput($event)"
            (focus)="onSalesPersonInputFocus()" (blur)="onSalesPersonInputBlur()" autocomplete="off" />

          <!-- Sales Person Search Results Dropdown -->
          <div class="dropdown-menu show w-100 mh-300px overflow-auto"
            *ngIf="showSalesPersonDropdown && (salesPersonSearchResults.length > 0 || isSalesPersonSearching)">

            <!-- Loading State -->
            <div class="dropdown-item text-center py-3" *ngIf="isSalesPersonSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching sales persons...
            </div>

            <!-- Search Results -->
            <a class="dropdown-item cursor-pointer py-2" *ngFor="let salesPerson of salesPersonSearchResults"
              (click)="selectSalesPerson(salesPerson)">
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ getSalesPersonDisplayName(salesPerson) }}</span>
                <small class="text-muted">{{ salesPerson.email }}</small>
              </div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
              *ngIf="!isSalesPersonSearching && salesPersonSearchResults.length === 0">
              No sales persons found
            </div>
          </div>
        </div>
      </div>


      <!-- Proforma No -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Proforma No</label>
        <input type="text" class="form-control form-control-sm" placeholder="Enter Proforma No..."
          [(ngModel)]="filters.proforma_no">
      </div>

      <!-- Chassis No -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Chassis No</label>
        <input type="text" class="form-control form-control-sm" placeholder="Enter Chassis No..."
          [(ngModel)]="filters.chassis_no">
      </div>
    </div>

    <!-- Second Row -->
    <div class="row g-4 mt-2">
      <!-- From Country -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">From Country</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.from_country"
          (change)="onFromCountryChange($event)">
          <option value="">Select From Country</option>
          <option *ngFor="let country of countries" [value]="country.code">
            {{ country.name }}
          </option>
        </select>
      </div>

      <!-- From Port -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">From Port</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.from_port"
          [disabled]="!filters.from_country || isLoadingFromPorts">
          <option value="">Select From Port</option>
          <option value="" *ngIf="isLoadingFromPorts">Loading ports...</option>
          <option *ngFor="let port of fromPorts" [value]="port.name">
            {{ port.name }}
          </option>
        </select>
      </div>

      <!-- To Country -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">To Country</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.to_country"
          (change)="onToCountryChange($event)">
          <option value="">Select To Country</option>
          <option *ngFor="let country of countries" [value]="country.code">
            {{ country.name }}
          </option>
        </select>
      </div>

      <!-- To Port -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">To Port</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.to_port"
          [disabled]="!filters.to_country || isLoadingToPorts">
          <option value="">Select To Port</option>
          <option value="" *ngIf="isLoadingToPorts">Loading ports...</option>
          <option *ngFor="let port of toPorts" [value]="port.name">
            {{ port.name }}
          </option>
        </select>
      </div>
    </div>

    <!-- Third Row -->
    <div class="row g-4 mt-2">
      <!-- Bank -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Bank</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.bank">
          <option value="">Select Bank</option>
          <option *ngFor="let bank of banks" [value]="bank._id">
            {{ bank.name }}
          </option>
        </select>
      </div>

      <!-- Stock Number -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Stock Number</label>
        <input type="text" class="form-control form-control-sm" placeholder="Enter Stock Number..."
          [(ngModel)]="filters.stock_number">
      </div>
    </div>



    <!-- Filter Actions -->
    <div class="d-flex justify-content-end mt-4">
      <button type="button" class="btn btn-sm btn-light me-3" (click)="clearFilters()" [disabled]="!hasActiveFilters()">
        <i class="ki-duotone ki-cross fs-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Clear All
      </button>
      <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
        <i class="ki-duotone ki-magnifier fs-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Apply
      </button>
    </div>
  </div>

  <div class="card-header align-items-center py-5 gap-2 gap-md-5">
    <div class="card-title">
      <!-- <div class="d-flex align-items-center position-relative me-2">
				<i class="ki-duotone ki-magnifier fs-3 position-absolute ms-4">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				<input type="text" class="form-control form-control-sm w-250px ps-12" placeholder="Search Order"
					   [(ngModel)]="searchTerm" (keyup.enter)="onSearch(searchTerm)" />
			</div> -->
    </div>
    <div class="card-toolbar flex-row-fluid justify-content-end gap-3">
      <div class="d-inline-flex justify-content-end align-items-center gap-4" data-table-toolbar="base">
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex" [class.active]="showFilters"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Search</span>
          <span class="badge badge-danger ms-2" *ngIf="hasActiveFilters()">{{ getActiveFiltersCount() }}</span>
        </button>
        <button type="button" class="btn btn-sm btn-primary d-flex" data-bs-toggle="modal"
          data-bs-target="#kt_export_modal">
          <i class="ki-duotone ki-exit-up fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Export</span>
        </button>
        <div class="w-100 mw-150px">
          <select class="form-select form-select-sm" data-hide-search="true" data-placeholder="Status">
            <option value="" selected disabled>Status</option>
            <option value="all">All</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Completed">Completed</option>
            <option value="Denied">Denied</option>
            <option value="Expired">Expired</option>
            <option value="Failed">Failed</option>
            <option value="Pending">Pending</option>
            <option value="Processing">Processing</option>
            <option value="Refunded">Refunded</option>
            <option value="Delivered">Delivered</option>
            <option value="Delivering">Delivering</option>
          </select>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-center d-none">
        <div class="fw-bold me-5">
          <span class="me-2">0</span>Selected
        </div>
        <button type="button" class="btn btn-sm btn-dark">Delete Selected</button>
      </div>
    </div>
  </div>

  <div class="card-body pt-0">
    <table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden">
      <thead>
        <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
          <th class="text-start w-10px pe-2">
            <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
              <input class="form-check-input" type="checkbox" value="1" />
            </div>
          </th>
          <th class="text-start min-w-100px text-nowrap">Proforma No</th>
          <th class="text-start min-w-175px">Proforma Details</th>
          <th class="text-start min-w-100px">Status</th>
          <th class="text-stat min-w-70px">Buyer Details</th>
          <th class="text-stat min-w-100px">Vehicle Details</th>
          <th class="text-stat min-w-100px">Shipping Details</th>
          <th class="text-start min-w-125px">Created Date</th>
          <th class="text-start min-w-100px">Actions</th>
        </tr>
      </thead>
      <tbody class="fw-semibold text-gray-600">
        <!-- Static reference row for comparison -->

        <!-- Loading state -->
        <tr *ngIf="isLoading">
          <td colspan="9" class="text-center py-5">
            <div class="d-flex justify-content-center align-items-center">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Loading proformas...
            </div>
          </td>
        </tr>

        <!-- No data state -->
        <tr *ngIf="!isLoading && proformas.length === 0">
          <td colspan="9" class="text-center py-5 text-muted">
            No proformas found
          </td>
        </tr>

        <!-- Data rows -->
        <tr *ngFor="let proforma of proformas; trackBy: trackByProformaId">
          <td class="text-start">
            <div class="form-check form-check-sm form-check-custom form-check-solid">
              <input class="form-check-input" type="checkbox" [value]="proforma._id" />
            </div>
          </td>
          <td class="text-start">
            <a href="#" class="text-gray-800 text-hover-primary fw-bold">{{ proforma.order_number || '-' }}</a>
          </td>
          <td class="text-start">
            <div class="d-flex flex-column">
              <p class="m-0"><b style="color: blue;">Total Price : </b> {{ getTotalPrice(proforma) }}</p>
              <p class="m-0"><b>On : </b> {{ formatDate(proforma.order_date) }}</p>
              <p class="m-0"><b>Created By : </b>{{ proforma.created_by?.name || '-' }}</p>
              <a href="javascript:;" (click)="SwitchToInvoice(proforma._id)"
                *ngIf="!proforma.switched_to_invoice">Switch to Invoice</a>
              <p class="m-0" *ngIf="proforma.switched_to_invoice"><b>Switched to Invoice</b></p>
              <!-- <p class="m-0" *ngFor="let invoice_number of proforma.invoice_numbers"><b>{{invoice_number}} </b></p> -->
              <p class="m-0"><b>Group No : </b> {{ proforma.group_no || '-' }}</p>
              <p class="m-0"><b style="color: red">Balance : </b> -</p>
              <p class="m-0" *ngFor="let invoice of proforma.invoices"><b>{{invoice?.vehicle?.car_no}} : {{
                  getInvoiceBalancePercentage(invoice) }}% </b></p>


              <!-- Status indicators when already marked -->
              <p class="m-0" *ngIf="proforma.surrendered">
                <i class="ki-duotone ki-check-circle fs-6 text-success me-1">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <b style="color: orange;">Surrendered</b>
              </p>
              <p class="m-0" *ngIf="proforma.docs_released">
                <i class="ki-duotone ki-check-circle fs-6 text-success me-1">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <b style="color: blue;">Docs Released</b>
              </p>

              <!-- Action buttons when not yet marked and BL is OK -->
              <div class="mt-2"
                *ngIf="proforma.is_paid && proforma.bl_ok === true && (!proforma.surrendered || !proforma.docs_released)">
                <button type="button" class="btn btn-sm btn-warning me-2" (click)="markAsSurrendered(proforma._id)"
                  *ngIf="!proforma.surrendered">
                  Surrender
                </button>
                <button type="button" class="btn btn-sm btn-info" (click)="markAsDocsReleased(proforma)"
                  *ngIf="!proforma.docs_released">
                  Docs Released
                </button>
              </div>

              <!-- Ship Request button -->
              <div class="mt-2" *ngIf="proforma.allow_shipping && !proforma.ship_requested">
                <button type="button" class="btn btn-sm btn-primary" (click)="requestShipping(proforma)">
                  Ship Request
                </button>
              </div>
            </div>
          </td>
          <td class="text-start" data-order="Completed">
            <!--begin::Badges-->
            <div class="badge badge-light-success">Active</div>
            <!--end::Badges-->
          </td>
          <td class="text-start">
            <div class="d-flex flex-column">
              <p class="m-0"><a title="Click to view Consignee Details" (click)="viewDetailClient(proforma?.buyer_id)" style="cursor: pointer;"><b>{{proforma.buyer_consignee_name || '-' }}</b></a></p>
              <p class="m-0"> {{ proforma.buyer_company_name || '-' }}</p>
              <p class="m-0">{{ proforma.buyer_street_address || '-' }}</p>
              <p class="m-0">{{ proforma.buyer_city || '-' }}, {{ proforma.buyer_country || '-' }}</p>
              <p class="m-0"><b>E-mail : </b> {{ proforma.buyer_email_address || '-' }}</p>
              <p class="m-0"><b>TEL No. : </b> {{ proforma.buyer_telephone_no || '-' }}</p>
            </div>
          </td>
          <td class="text-start pe-0">
            <div *ngIf="proforma.vehicles && proforma.vehicles.length > 0; else noVehicles">
              <ul>
                <li *ngFor="let vehicle of proforma.vehicles">
                  <a href="javascript:;" class="text-primary text-hover-primary"
                    (click)="openVehicleDetailModal(vehicle,proforma._id)">
                    {{ vehicle.car_no || '-' }} {{ vehicle.name || '-' }} {{ vehicle.year || '-' }} - {{
                    vehicle.vin_no || '-' }}
                  </a>
                </li>
              </ul>

              <!-- BL Status indicators when already set -->
              <div class="mt-2" *ngIf="proforma.bl_ok !== undefined">
                <p class="m-0" *ngIf="proforma.bl_ok === true">
                  <i class="ki-duotone ki-check-circle fs-6 text-success me-1">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                  <b style="color: green;">BL OK</b>
                </p>
                <p class="m-0" *ngIf="proforma.bl_ok === false">
                  <i class="ki-duotone ki-cross-circle fs-6 text-danger me-1">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                  <b style="color: red;">BL Not OK</b>
                </p>
              </div>

              <!-- BL Form buttons when bl_ok is strictly false -->
              <div class="mt-2" *ngIf="proforma.bl_ok === false && proforma.bl_form_stage">
                <button type="button" class="btn btn-sm btn-primary me-1" *ngIf="(proforma.bl_form_stage || 0) >= 1"
                  (click)="openBlAmendForm(proforma, 1)">
                  BL Form 1
                </button>
                <button type="button" class="btn btn-sm btn-primary me-1" *ngIf="(proforma.bl_form_stage || 0) >= 2"
                  (click)="openBlAmendForm(proforma, 2)">
                  BL Form 2
                </button>
                <button type="button" class="btn btn-sm btn-primary" *ngIf="(proforma.bl_form_stage || 0) >= 3"
                  (click)="openBlAmendForm(proforma, 3)">
                  BL Form 3
                </button>
              </div>

              <!-- BL Action buttons when not yet set -->
              <div class="mt-2"
                *ngIf="showBlButtons(proforma) && (proforma.bl_ok === undefined || proforma.bl_ok === null)">
                <button type="button" class="btn btn-sm btn-success me-2" (click)="updateBLStatus(proforma._id, true)">
                  BL Ok
                </button>
                <button type="button" class="btn btn-sm btn-danger" (click)="updateBLStatus(proforma._id, false)">
                  BL Not Ok
                </button>
              </div>
            </div>
            <ng-template #noVehicles>
              <span>-</span>
            </ng-template>
          </td>
          <td class="text-start">
            <div class="d-flex flex-column" *ngIf="proforma.invoices?.[0]?.ship as ship; else noShip">
              <p class="m-0"><b>To : </b> {{ ship.destination_country || '-' }}, {{ ship.destination_port || '-' }}</p>
              <p class="m-0"><b>From :</b> {{ ship.sailing_port || '-' }}, Japan</p>
              <p class="m-0"><b>ETD : </b> {{ formatDate(ship.sailing_date) || '-' }}</p>
              <p class="m-0"><b>ETA : </b> {{ formatDate(ship.arrival_date) || '-' }}</p>
              <p class="m-0"><b>Ship : </b> {{ ship.name || '-' }}</p>
              <p class="m-0"><b>Voyage : </b> {{ ship.voyage_no || '-' }}</p>
              <p class="m-0 text-first-letter-upc"><b>Shipping Status : </b> {{ proforma.invoices?.[0]?.shipping_info?.status || '-' }}</p>
              <p class="m-0"><b>Shipping Company : </b> {{ ship.company || '-' }}</p>
            </div>

            <ng-template #noShip>
              <div class="d-flex flex-column">
                <p class="m-0"><b>To : </b> {{ proforma.to_country || '-' }}, {{ proforma.to_port || '-' }}</p>
                <p class="m-0"><b>From :</b> {{ proforma.from_country || '-' }}, {{ proforma.from_port || '-' }}</p>
                <p class="m-0"><b>ETD : </b> -</p>
                <p class="m-0"><b>ETA : </b> -</p>
                <p class="m-0"><b>Ship : </b> -</p>
                <p class="m-0"><b>Voyage : </b> -</p>
                <p class="m-0 text-first-letter-upc"><b>Shipping Status : </b> {{ proforma.invoices?.[0]?.shipping_info?.status || '-' }}</p>
                <p class="m-0"><b>Shipping Company : </b> -</p>
              </div>
            </ng-template>
          </td>
          <td>{{ formatDate(proforma.created_at) }}</td>

          <td class="text-end">
            <div class="d-flex flex-column align-items-end ">

              <button type="button" class="btn btn-icon btn-sm btn-light-primary me-2 action-buttons"
                (click)="editProforma(proforma); $event.preventDefault()" title="Edit Proforma">
                <i class="ki-duotone ki-pencil fs-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
              <!-- Edit Button -->
              <button type="button" class="btn btn-light-primary me-2 action-buttons"
                (click)="openProformaPreview(proforma); $event.preventDefault()" title="Preview Proforma 1">
                Proforma 1
              </button>

              <button type="button" class="btn btn-light-primary me-2 action-buttons"
                (click)="openProformaTwoPreview(proforma); $event.preventDefault()" title="Preview Proforma 2">
                Proforma 2
              </button>
            </div>
          </td>

        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="card-footer" *ngIf="!isLoading && proformas.length > 0">
    <app-pagination [paginationInfo]="paginationInfo" [loading]="isLoading" (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>

<app-export-modal></app-export-modal>
<app-bl-amend-form></app-bl-amend-form>
<app-proforma-docs-release (formSubmitted)="onDocsReleaseFormSubmit($event)"></app-proforma-docs-release>
<app-proforma-ship-request (formSubmitted)="onShipRequestFormSubmit()"></app-proforma-ship-request>
